module.exports = __webpack_public_path__ + "components/forecast-table/tooltips/static/snowfall-c49bacfbd74b7f1755d1718f12154165.jpg";